<div class="container">
    <form class="form-signin" (ngSubmit)="OnLogin(f)" #f="ngForm">
        <div class="text-center mb-4">
            <img class="mb-4 img-thumbnail img-circle" src="../../../../assets/brand/Logo.png" alt="" width="72" height="72">
            <!-- <h1 class="h3 mb-3 font-weight-normal">Login</h1> -->
        </div>

        <span *ngIf="f.submitted && f.controls['nombrelogin'].errors" class="text-danger animated fadeIn">Nombre de usuario requerido</span>
        <div class="form-label-group">
            <input type="email" id="inputEmail" name="nombrelogin" [(ngModel)]="login.nombrelogin" class="form-control" placeholder="Email address" required autofocus>
            <label for="inputEmail" required>Usuario</label>
        </div>

        <span *ngIf="f.submitted && f.controls['pass'].errors" class="text-danger animated fadeIn">Contraseña requerida</span>
        <div class="form-label-group">
            <input type="password" id="inputPassword" name="pass" [(ngModel)]="login.pass" class="form-control" placeholder="Password" required>
            <label for="inputPassword" required>Cotraseña</label>
        </div>

        <div class="checkbox mb-3">
            <label>
      <input type="checkbox" value="remember-me" name="recordarme" [(ngModel)]="recordarme"> Recordarme
    </label>
        </div>
        <button class="btn btn-lg btn-primary btn-block" type="submit">Ingresar</button>
        <!-- <p class="mt-5 mb-3 text-muted text-center">&copy;{{anio}} Inmobilairia Primo</p> -->
    </form>

    <app-alert *ngIf="error"  [msjError]="msjError"></app-alert>
</div>